import { clampNumber } from "./clamp-number";

function getClampedSeekTimeSeconds(
  nextTimeSeconds: number,
  durationSeconds: number,
): number | undefined {
  if (!Number.isFinite(nextTimeSeconds) || !Number.isFinite(durationSeconds)) {
    return undefined;
  }

  if (durationSeconds <= 0) {
    return undefined;
  }

  return clampNumber(nextTimeSeconds, 0, durationSeconds);
}

export { getClampedSeekTimeSeconds };
